import { BlankEditorResult } from '@doltech/ui/lib/figma/BlankEditor/Result/BlankEditorResult';
import { Box } from '@doltech/ui/lib/figma/Common/Box';
import { TestModeEnum } from '@doltech/utils/lib/constants';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { Heading } from '../../../student-do-test-questions/CompletionNoHintAnswer';
import { ResultCompletionNoHintQuestionInstance } from '../../model/Question/result-completion-no-hint-question.store';
import { ExtraQuestionProps } from './BaseQuestion';

interface CompletionNoHintQuestionResultProps extends React.HTMLAttributes<HTMLDivElement> {
  data: ResultCompletionNoHintQuestionInstance & ExtraQuestionProps;
  testMode: TestModeEnum;
}

const QuestionList = styled.div`
  display: grid;
  gap: 16px;
`;

export const CompletionNoHintAnswerResult = observer(
  (props: CompletionNoHintQuestionResultProps) => {
    const { data, testMode } = props;
    const { no, heading, paragraph, index } = data;

    return (
      <Box key={no} className="dol-question sentence-complete-answer">
        <QuestionList>
          <Heading>{heading}</Heading>
          <BlankEditorResult
            key={paragraph.id}
            value={paragraph.editorValueJS}
            blanks={paragraph.blanks}
            testMode={testMode}
            currentSelectedIndex={index}
          />
        </QuestionList>
      </Box>
    );
  }
);
